export const ytEmbedUrl = (videoId, opts = {}) => {
  const params = new URLSearchParams({
    rel: "0",
    modestbranding: "1",
    color: "white",
    ...opts,
  });
  return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
};

export const ytWatchUrl = (videoId) =>
  `https://www.youtube.com/watch?v=${videoId}`;

export const ytThumbUrl = (videoId, q = "maxresdefault") =>
  `https://i.ytimg.com/vi/${videoId}/${q}.jpg`;
